import React from 'react';
import './NishRenew.css';

const NishRenew: React.FC = () => {
  // Referans sitedeki tüm koltuk görselleri
  const products = [
    {
      image: 'https://static.wixstatic.com/media/e733f0_29d6314df0274c10aca3b3a61f229558~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_29d6314df0274c10aca3b3a61f229558~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_c47188d2c1a44cd8a89afa91eec4ff89~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_c47188d2c1a44cd8a89afa91eec4ff89~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_ddf2da3ace784089bac0f553872f6140~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_ddf2da3ace784089bac0f553872f6140~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_8f631652904d4edca0922af94b492771~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_8f631652904d4edca0922af94b492771~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_fafbc49582764116ba82db59fb34a610~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_fafbc49582764116ba82db59fb34a610~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_527e10734bb040ec8baf8f5474545402~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_527e10734bb040ec8baf8f5474545402~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_5369850685a745c6b854123dfe88b8ff~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_5369850685a745c6b854123dfe88b8ff~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_e718668349cc4ff380660f95738ae257~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_e718668349cc4ff380660f95738ae257~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_3f84acf1f92d4783aa8890253d13ef9d~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_3f84acf1f92d4783aa8890253d13ef9d~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_ab68b930432a4f0fa3edc662e8705c18~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_ab68b930432a4f0fa3edc662e8705c18~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_5e7b8ba55aca4bf49b96cac628daf19d~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_5e7b8ba55aca4bf49b96cac628daf19d~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_5e0a7d5ee58247a4886ac3297561f37a~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_5e0a7d5ee58247a4886ac3297561f37a~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_9f24fcc7eac84d0b99bba6b92e37eb7f~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_9f24fcc7eac84d0b99bba6b92e37eb7f~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_7cbd03904d6d4681806016fbc3564ba9~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_7cbd03904d6d4681806016fbc3564ba9~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_8164457e9ff24dbc944aca7aa78e307f~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_8164457e9ff24dbc944aca7aa78e307f~mv2.jpeg'
    },
    {
      image: 'https://static.wixstatic.com/media/e733f0_04cb49668c3c4e858d0d92384beda070~mv2.jpeg/v1/fill/w_450,h_450,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e733f0_04cb49668c3c4e858d0d92384beda070~mv2.jpeg'
    }
  ];

  return (
    <div className="nish-renew-page">
      <div className="nish-renew-header">
        <h1 className="nish-renew-title">Welcome to the Renewed Products Category</h1>
        <p className="nish-renew-description">
          The conference chairs you see here are products with a history yet ready for the future.
          Carefully removed from various hall projects completed by Nish Global, these conference chairs
          are prepared to be re-evaluated specifically for your project.
        </p>
        <p className="nish-renew-description">
          Removed from university halls, municipal conference centers and cultural event venues, these
          chairs undergo technical inspection, and every part that needs attention is meticulously handled.
        </p>
      </div>
      <div className="products-grid">
        {products.map((product, index) => (
          <img key={index} src={product.image} alt="Renewed Conference Chair" />
        ))}
      </div>
    </div>
  );
};

export default NishRenew;
